import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const ProveedorApp = lazy(() => import('./view/Proveedor'))

export const proveedorRoutesMap = {
  proveedor: {
    path: '/proveedor/gestion',
    name: 'Proveedores',
    action: 'PROVEEDORES',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const proveedorRoutes = [
  {
    path: proveedorRoutesMap.proveedor.path,
    element: (
      <OperacionesProvider>
        <ProveedorApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default proveedorRoutes
